module.exports = new __parcel__URL__("controls.18bc7465.png").toString();